import { Button, Grid, MenuItem, Select, Typography } from '@mui/material'
import React from 'react'
import VerifiedIcon from '@mui/icons-material/Verified';  
import ImageView from './imageview/ImageView'
import { formarttoPiCurrency, truncateStringNoSuffix} from "../../utils/Utils"
import { useCallback } from 'react';
import CategoryIcon from '../../components/category/categoryIcon/CategoryIcon';
import { axiosClient, config } from '../../services/axiosClient';
import { ContentCopy } from '@mui/icons-material';
const ProductDetail = ({myCld,product,store,active,setActive ,verified,setVerified,message,setProductCategory,productCategory,selectedCategory,setSelectedCategory,setStoreMessage,messageTitle,setStoreMessageTitle}) => {
    console.log(product)
    const [titles,setTitles]=React.useState([])
    const [messages,setMessages]=React.useState([])
       const[categories]=React.useState(store.categories.length > 0 ? store.categories :[]);
    //
       const[filStoreProtCategories,setFilStoreProCategories]=React.useState([]);
    const[title,setTitle]=React.useState(0)
    const[messagev,setMessagev]=React.useState(0)
    const[isMessageLoaded,setIsMessagesLoaded]=React.useState(false)
    const [groupCategories,setGroupCategories]=React.useState([]);
    const [checkedCategories,setCheckedCategories]=React.useState(store.categories);
    const [isCategoriesLoaded,setIsCategoriesLoaded]=React.useState(false)
    const [productCategories,setProductCategories]=React.useState([]);
    const [isGroupLoaded,setIsGroupLoaded]=React.useState(false)
    const [productUrl] = React.useState(`${process.env.REACT_APP_WEBSITE_URL}/s/${store.tag}/${product._id}`);


      const ShareProductUrl = () =>{
               const [iscopied,setIscopied]=React.useState(false)
                return (
                   <Grid item>
                  { productUrl ? <Grid container justifyContent={'space-between'} alignItems={'center'} alignContent={'center'}>
                               
                               <Grid item xs={1} >
                       {iscopied ? <ContentCopy color='primary' sx={{transform:'scale(0.6)'}} onClick={() => { navigator.clipboard.writeText(`${productUrl}`);setIscopied(true)}}/>: <ContentCopy color='textGrey' sx={{transform:'scale(0.6)'}} onClick={() => { navigator.clipboard.writeText(`${productUrl}`);setIscopied(true)}}/>}
                       
                      </Grid> 
                     {/*  <Grid item xs={11}>
                  <Typography fontSize='0.7rem' overflow={true}>{`${storeUrl}`}</Typography>
                  </Grid> */}
                      </Grid>:''}
                  </Grid>
                  
                )
              }
    const onMessageChange =(e) =>{
        setMessagev(e.target.value)
        setStoreMessage({content:messages[e.target.value].content,link:messages[e.target.value].link})
    }

     const onMessageTitle =(e) =>{
        setTitle(e.target.value)
        setStoreMessageTitle(titles[e.target.value].title)
    }
     
        const filterProduct =useCallback((productCategories)=>{
                      var arr=[];
            
                       for (var i=0;i < categories.length;i++){
                        for(var j=0;j < productCategories.length;j++ ){
            
                              if (categories[i]._id===productCategories[j].categoryGroupId){
                                console.log(productCategories[j].categoryGroupId)
                                 
                                arr.push(productCategories[j])
                              }
                          }
                       }
                       setFilStoreProCategories(arr)
                       console.log(arr)
                     },[categories])

                     const onProductCategoryChange = (e) => {
        const val =e.target.value
        setSelectedCategory(val)
        const prodcat=productCategories.filter((item)=>item._id===val)
        setProductCategory(prodcat[0])
        console.log(prodcat)
      }
      React.useEffect(()=>{
         
            setTitles([{id:0,title:`None`},{id:1,title:`Product Update/Review`},{id:1,title:`Store Update/Review`}])
            setMessages([
        {id:0,content:`None`},
        {id:1,content:`Your product  "${product.name}" , is reviewed and added to listings`},
        {id:2,content:`Your product  "${product.name}" , is reviewed and added to listings,you have to update the product and set it to active before it will shown to users `},

        {id:3,content:`Please replace your product named "${product.name}" images to better images`,link:`/edit-product?productId=${product._id}&productName="${product.name}"&storeId=${store._id}&storeName=${store.name}`},
        {id:4,content:`Your product with name "${product.name}" should be specific to one product it seems you publsih different products in one, Delete and recreate them individually `,link:`/edit-product?productId=${product._id}&productName="${product.name}"&storeId=${store._id}&storeName=${store.name}`},
        {id:5,content:`Your product  "${product.name}" is a digital product please review it and add downloadble link , users will only have access after they make order`,link:`/edit-product?productId=${product._id}&productName="${product.name}"&storeId=${store._id}&storeName=${store.name}`},
        {id:6,content:`Your product  "${product.name}" violets our terms of service for displaying and promoting of elicit drugs,and its not allowed to be listed`,link:`/edit-product?productId=${product._id}&productName="${product.name}"&storeId=${store._id}&storeName=${store.name}`},
        {id:7,content:`Your product  "${product.name}" Category is updated `,link:`/edit-product?productId=${product._id}&productName="${product.name}"&storeId=${store._id}&storeName=${store.name}`},

        
    ])
         if (!isMessageLoaded){  }
          const getCategories= async()=>{
                       
                   const url = `${process.env.REACT_APP_SERVER_URL}/category`;
                   
                   return axiosClient.get(url,{},config).then((response)=>{
                      try{
                        if (response.status===200){
                         setProductCategories(response.data)
                         filterProduct(response.data)
                         //setProductCategories(getCheckedProductCats(response.data,product.category ? product.category :[]))
                        }
               
                      }catch(err){
                         console.log(err)
                      }
                   })
                 }
                  const handlegetGroup =async ()=>{
                             const url=`${process.env.REACT_APP_SERVER_URL}/category/group`
                     
                            await axiosClient.get(url,{},config).then((response)=>{
                                 //console.log(response.data)
                                 setGroupCategories(response.data);
                 
                             })  
                         }
                        
                         if (!isGroupLoaded){
                             handlegetGroup();
                         }
                if (!isCategoriesLoaded){
                    getCategories().then(()=>{
                        setIsCategoriesLoaded(true)
                    })
                }
          return ()=>{
            setIsMessagesLoaded(true)
            setIsGroupLoaded(true)
          }
        
      },[product.name, isMessageLoaded, product._id, store._id, store.name, filterProduct, isCategoriesLoaded, store.categories, isGroupLoaded])

  return (
         
            
    <Grid container justifyContent='space-between' >
        <Grid item xs={12} sm={12} md={12} lg={12} >
            
          <Grid container justifyContent={'space-between'} >

            <Grid item xs={12} sm={12} md={12} lg={12} >
        <Grid container justifyContent={'flex-start'} alignItems={'center'} >
            <Grid item >
            <img src={myCld.image(`${product.image[0].public_id}`).format('auto').quality('auto').addFlag('lossy').toURL()} alt="" className="productInfoImg" /> 
            </Grid>
            <Grid item>
             <Grid container justifyContent={'flex-start'}  >
                             <Grid item >
                             <Typography fontWeight={600} variant='h6' fontSize={'1rem'}>{product.name}</Typography>

                             </Grid>

                             <Grid item >

                                                          {
                              product.verified ? <VerifiedIcon style={{ color: 'violet' }} />  
                                :  <Typography variant='h6' color='darkgray' fontSize={'1rem'}> Unverified</Typography>

                              }
                             </Grid>
                             <Grid item >
                                  <ShareProductUrl />
                              </Grid>
                            </Grid>

            </Grid>
            
        </Grid>
          </Grid>

        <Grid item xs={12} sm={12} md={4} lg={4} className="pmproductInfoTopWrapper" padding={2} sx={{overflow:'scroll'}}>

           
          
        <Grid item xs={12} sm={12} md={12} lg={12}>
        <Grid container justifyContent={'space-between'} alignItems={'center'} >
            <Grid item>
            <Typography variant='body1' color={'darkgray'}>Price</Typography>
            </Grid>
            <Grid item>
            <Typography variant='body2'>{formarttoPiCurrency(product.price)}</Typography>

            </Grid>
        </Grid>
        </Grid>

      
        <Grid item xs={12} sm={12} md={12} lg={12}>
        <Grid container justifyContent={'space-between'} alignItems={'center'}>
            <Grid item>
            <Typography variant='body1' color={'darkgray'}>Shipping</Typography>
            </Grid>
            <Grid item>
            <Typography variant='body2'>{formarttoPiCurrency(product.shippingFees)}</Typography>

            </Grid>
        </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12}>
        <Grid container justifyContent={'space-between'} >
            <Grid item >
            <Typography variant='body1' color={'darkgray'}>Color</Typography>
            </Grid>
            <Grid item >
           <Grid container justifyContent={'space-between'} direction='column' >
           {product.color.map((color)=>{ 
            return  <Grid item >
                   <Typography variant='body2'>{color} </Typography>
                </Grid> })}
           </Grid>

            </Grid>
        </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12}>
        <Grid container justifyContent={'space-between'} >
            <Grid item >
            <Typography variant='body1' color={'darkgray'}>Size</Typography>
            </Grid>
            <Grid item >
           <Grid container justifyContent={'space-between'} direction='column' >
           {product.size.map((size)=>{ 
            return  <Grid item >
                   <Typography variant='body2'>{size} </Typography>
                </Grid> })}
           </Grid>

            </Grid>
        </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12}>
        <Grid container justifyContent={'space-between'} alignItems={'center'}>
            <Grid item>
            <Typography variant='body1' color={'darkgray'}>Stock</Typography>
            </Grid>
            <Grid item>
            <Typography variant='body2'>{product.stock.currentstock}</Typography>

            </Grid>
        </Grid>
        </Grid>
       
        <Grid item xs={12} sm={12} md={12} lg={12}>
        <Grid container justifyContent={'space-between'} alignItems={'center'}>
            <Grid item>
            <Typography variant='body1' color={'darkgray'}>Digital Product Link</Typography>
            </Grid>
            <Grid item>
            <Typography variant='body2'>{product.digital_product_url}</Typography>

            </Grid>
        </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12}>
        <Grid container justifyContent={'space-between'} alignItems={'center'}>
            <Grid item>
            <Typography variant='body1' color={'darkgray'}>Country Scope</Typography>
            </Grid>
            <Grid item>
            <Typography variant='body2'>{`${product.countryScope.map((scope)=>{return scope.name})},`}</Typography>

            </Grid>
        </Grid>
        </Grid>
        
         <Grid item xs={12} sm={12} md={12} lg={12}>
        <Grid container justifyContent={'space-between'} alignItems={'center'}>
            <Grid item>
            <Typography variant='body1' color={'darkgray'}>Category</Typography>
            </Grid>
            <Grid item xs={8}>
           <Typography variant='body2'>{product.category.name}</Typography>
           <Select value={productCategory._id} variant='outlined' name="country"  /* required */  onChange={onProductCategoryChange} fullWidth 
            sx={{
              
             "& .MuiOutlinedInput-root": {  
               padding: "4px", // Outer padding adjustment  
             },  
             "& .MuiInputBase-input": {  
               padding: "8px", // Inner padding adjustment  
               fontSize: "12px", // Adjust font size  
               backgroundColor:'#fff',
             },  
           
           }}  
           >

           <MenuItem   value={null}></MenuItem>
            
                   {productCategories.map((cat,index)=>(
                      <MenuItem sx={{fontSize:'0.7rem',margin:0,padding:0}}   key={index} value={cat._id}>
                       <Grid container justifyContent='flex-start'>
                   <Grid item xs={1}>
                   <CategoryIcon category={cat}/>
                   </Grid>
                   <Grid item xs={11}>
                   <Typography>{truncateStringNoSuffix(cat.name,35)}</Typography>
                   </Grid>
                   
               </Grid>
                      </MenuItem>
                  ))}
                  </Select> 
            </Grid>
        </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12}>
        <Grid container justifyContent={'space-between'} alignItems={'center'}>
            <Grid item>
            <Typography variant='body1' color={'darkgray'}>Active</Typography>
            </Grid>
            <Grid item>
            <Typography variant='body2'>{product.active}</Typography>

            </Grid>
        </Grid>
        </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12}>
        <Grid container justifyContent={'space-between'} alignItems={'center'}>
            <Grid item>
            <Typography variant='body1' color={'darkgray'}>Life Span</Typography>
            </Grid>
            <Grid item>
            <Typography variant='body2'>{product.lifespan}</Typography>

            </Grid>
        </Grid>
        </Grid>

       {/*  <Grid item xs={12} sm={12} md={12} lg={12}>
        <Grid container justifyContent={'space-between'} alignItems={'center'}>
            <Grid item>
            <Typography variant='body1' color={'darkgray'}>Verified</Typography>
            </Grid>
            <Grid item>
            <Typography variant='body2'>{`${product.verified}`}</Typography>

            </Grid>
        </Grid>
        </Grid> */}

        <Grid item xs={12} sm={12} md={12} lg={12}>
        <Grid container justifyContent={'space-between'} alignItems={'center'}>
            <Grid item>
            <Typography variant='body1' color={'darkgray'}>Date</Typography>
            </Grid>
            <Grid item>
            <Typography variant='body2'>{new Date(product.dateCreated).toISOString()}</Typography>

            </Grid>
        </Grid>
        </Grid>
       <hr style={{margin:1}} />
        {
            store ?  <Grid item xs={12} sm={12} md={12} lg={12} marginTop={1}>
            <Grid container justifyContent={'space-between'}  direction={'column'}>
                <Grid item>
                <Typography variant='body1' color={'darkgray'}>Merchant</Typography>
                </Grid>
                <Grid item>
                <Grid container justifyContent={'space-between'}>
                {/* <Grid item>
                <Typography variant='body2'>Name </Typography>
                </Grid> */}
                <Grid item marginBottom={1}>
                  <Typography variant='body2'>{store.name}</Typography>
                </Grid>
                </Grid>
    
                </Grid>

                <Grid item>
                <Typography variant='body1' color={'darkgray'}>Phone </Typography>
                </Grid>
                <Grid item>
                <Grid container justifyContent={'space-between'}>
                {/* <Grid item>
                <Typography variant='body2'>Name </Typography>
                </Grid> */}
                <Grid item marginBottom={1}>
                  <Typography variant='body2'>{store.phone}</Typography>
                </Grid>
                </Grid>
    
                </Grid>

                <Grid item>
                <Typography variant='body1' color={'darkgray'}>Email </Typography>
                </Grid>
                <Grid item>
                <Grid container justifyContent={'space-between'}>
                {/* <Grid item>
                <Typography variant='body2'>Name </Typography>
                </Grid> */}
                <Grid item marginBottom={1}>
                  <Typography variant='body2'>{store.email}</Typography>
                </Grid>
                </Grid>
    
                </Grid>

                <Grid item>
                <Grid container justifyContent={'space-between'}>
                <Grid item>
                <Typography variant='body2' color={'darkgray'}>Country </Typography>
                </Grid>
                <Grid item>
                  <Typography variant='body2'>{store.country.name}</Typography>
                </Grid>
                </Grid>
    
                </Grid>
                
                <Grid item marginTop={1}>
                <Grid container justifyContent={'space-between'}>
                <Grid item>
                <Typography variant='body2' color={'darkgray'}>StoreCategory</Typography>
                </Grid>
                <Grid item>
                    <Grid container justifyContent={'space-between'}>
                    {store.categories.map   ((category)=>{
                        return  <Grid item >
                        <Typography variant='body2'>{`${category.name},`}</Typography>
                        </Grid>
                        
                        
                        })}
                       
                    </Grid>
                </Grid>
                
                </Grid>

                </Grid>
            </Grid>
            </Grid>:''
        }


            </Grid>


            <Grid item xs={12} sm={12} md={7} lg={7} padding={1}>
            <ImageView images={product.image}/>
               
            </Grid>


          </Grid>  
      <Grid item xs={12} sm={12} md={12} lg={12}  >
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <Grid container justifyContent={'flex-start'} alignItems={'flex-start'} direction={'column'} spacing={2}>
            <Grid item justifyContent={'flex-start'} >
            <Typography variant='body1' color={'darkgray'}>Description</Typography>
            </Grid>
            <Grid item  justifyContent={'flex-start'}>
            <Typography variant='body2'>{product.description}</Typography>

            </Grid>
        </Grid>
        </Grid>
     </Grid>
        </Grid>
      
    
        <Grid item xs={12} sm={12}>
           <Grid container justifyContent='flex-start' direction={'column'} spacing={1} >
               <Grid item >
               <Grid container justifyContent={'space-between'} spacing={1}>
                    <Grid item xs={6} >
                <div className='formItem'>
            <label>Verified</label>
            <Select variant="standard" value={verified} name="varified"  required fullWidth onChange={(e)=>{setVerified(e.target.value)}}>
        <MenuItem key={0} value={true}>true</MenuItem>
        <MenuItem key={1} value={false}>false</MenuItem>

     
       </Select> 
            </div>
                    </Grid>
                    <Grid item xs={6}>
              <div className='formItem'>
            <label>Active</label>
            <Select variant="standard" value={active} name="active"  required fullWidth onChange={(e)=>{setActive(e.target.value)}}>
        <MenuItem key={0} value={'yes'}>Yes</MenuItem>
        <MenuItem key={1} value={'no'}>No</MenuItem>

     
       </Select>     
           
            </div>
            </Grid>
                  </Grid>
            </Grid>
           <Grid item xs={12} marginTop={4} border={'0px solid darkgrey'} padding={4}>
                    <Grid container justifyContent='space-between' spacing={3} alignContent={'center'} >

                    <Grid item xs={12}>
                        {/*  <TextField
                    fullWidth
                    variant='standard'
                     value={messageTitle}
                     label='Title'
                     onChange={(e)=>{onMessageTitle(e)}}
                    InputProps={{}}
                    >

                         </TextField> */}
             
            <Select variant="outlined"  value={title} name="title"  required fullWidth onChange={(e)=>{onMessageTitle(e)}} >
       
           {
            titles.map((t,i)=>{
                return (
                    <MenuItem  key={`msg-${i}`} value={t.id} > {t.title} </MenuItem>
                )
            })
           }

     
       </Select>     
                       </Grid>
                       <Grid item xs={12}>

                       <Select variant="outlined"  value={messagev} name="message"  required fullWidth onChange={(e)=>{onMessageChange(e)}} >
       
                         {
                              messages.map((m,i)=> {
                              return (
                              <MenuItem  key={`msg-${i}`} value={m.id} > {m.content} </MenuItem>
                                  )
                              })
                             }

 
   </Select>  
                       {/*   <TextField
                    fullWidth
                    variant='standard'
                     value={message}
                     label='Message'
                     onChange={(e)=>{onMessageChange(e)}}
                    InputProps={{}}
                    >

                         </TextField> */}
                       </Grid>
                    </Grid>
           </Grid>
              <Grid item marginTop={4}>
                <Grid container justifyContent={'center'}>
                    <Grid item xs={12}>
                    <Button variant='outlined' color='primary' type="submit" fullWidth >Update</Button>
                    </Grid>
                 </Grid>
            </Grid>
           </Grid>
        </Grid>
   </Grid>
     )
  }

export default ProductDetail
